import React, { useRef, useCallback } from 'react';
import { Button, ButtonGroup } from 'ui';
import useEventListener from 'components/shared/hooks/useEventListener';

const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;

export const LessonNavigation = props => {
  const {
    isFirstSection,
    previousLearningPath,
    hasMissedAnswers,
    nextLearningPath,
    isLastSection,
    isPreviewing,
    shouldRate,
    finished,
    finishLearningPath,
    reportCardLearningPath,
    ratingsLearningPath,
  } = props;

  const backwardRef = useRef();
  const forwardRef = useRef();

  const handler = useCallback(
    e => {
      const { keyCode, ctrlKey, shiftKey, metaKey } = e;

      const specialKey = ctrlKey || shiftKey || metaKey;
      const currentFocusedElement =
        document.activeElement.tagName.toLowerCase();
      const isInputFocused = currentFocusedElement === 'input';
      const isTextareaFocused = currentFocusedElement === 'textarea';
      const isSelectFocused = currentFocusedElement === 'select';

      if (
        specialKey ||
        isInputFocused ||
        isTextareaFocused ||
        isSelectFocused
      ) {
        return;
      }

      // Click element when correct arrow key is used and element is renderend on the screen
      if (keyCode === LEFT_ARROW && backwardRef.current) {
        backwardRef.current.click();
      } else if (
        keyCode === RIGHT_ARROW &&
        forwardRef.current &&
        !isLastSection
      ) {
        forwardRef.current.click();
      }
    },
    [isLastSection],
  );

  useEventListener('keydown', handler);

  const renderBackwardButton = () => {
    if (!isFirstSection) {
      const PREVIOUS_TEXT = t('lesson_navigation.previous');
      return (
        <Button
          className="back LessonNavigation-button"
          type="button"
          url={previousLearningPath}
          ref={backwardRef}
          ariaLabel={PREVIOUS_TEXT}
        >
          {PREVIOUS_TEXT}
        </Button>
      );
    }

    return <></>;
  };

  const renderForwardButton = () => {
    if (hasMissedAnswers) {
      return <></>;
    }

    let attributes = { url: nextLearningPath };
    let text = 'lesson_navigation.next';

    if (isLastSection) {
      if (isPreviewing) {
        return <></>;
      }

      const dataBehaviors = shouldRate
        ? 'scorm_finished_link ask_for_learner_feedback'
        : 'scorm_finished_link';
      attributes = finished
        ? { url: reportCardLearningPath }
        : {
            'data-ratings-url': ratingsLearningPath,
            'data-behavior': dataBehaviors,
            'data-method': 'post',
            url: finishLearningPath,
          };
      text = finished
        ? 'progress.view_report_card'
        : 'lesson_navigation.complete';
    }

    return (
      <Button
        className="LessonNavigation-button forward"
        customColor
        type="button"
        ref={forwardRef}
        ariaLabel={t(text)}
        {...attributes}
      >
        {t(text)}
      </Button>
    );
  };

  return (
    <div className="LessonNavigation">
      <ButtonGroup alignEnd className="LessonNavigation-button-container">
        {renderBackwardButton()}
        {renderForwardButton()}
      </ButtonGroup>
    </div>
  );
};

export default LessonNavigation;
